import pagination from '@iso/lib/helpers/pagination';
import { createReducer } from 'reduxsauce';
import initialState from './model';

const {
    actions: baseActions,
    types: paginationTypes,
    reducer: paginationReducer,
} = pagination('sales');

const paginationActions = {
    requestFetchSales: baseActions.request,
    fetchSalesSucceeded: baseActions.succeeded,
    fetchSalesFailed: baseActions.failed,
};

export const types = { ...paginationTypes };

export const actions = { ...paginationActions};

export default createReducer(initialState, {
    // get sales list
    ...paginationReducer,
});